import { render, staticRenderFns } from "./WxNeiling.vue?vue&type=template&id=97748b28&scoped=true&"
import script from "./WxNeiling.vue?vue&type=script&lang=js&"
export * from "./WxNeiling.vue?vue&type=script&lang=js&"
import style0 from "./WxNeiling.vue?vue&type=style&index=0&id=97748b28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97748b28",
  null
  
)

export default component.exports